import script from "./ShiftCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ShiftCalendar.vue?vue&type=style&index=0&id=84e47704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84e47704"]])

export default __exports__